import { PdfButton } from "../PdfButton";

export const CyberHero = ({ user, today, children }) => (
  <section className="cyber-hero relative overflow-hidden border border-[#1e3a8a] text-white fade-up" data-testid="cyber-hero">
    <div className="cyber-grid absolute inset-0" />
    <div className="cyber-scan absolute inset-x-0 h-24" />
    <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#0ea5e9]/25 blur-3xl" />
    <div className="absolute -bottom-32 left-1/3 h-72 w-72 rounded-full bg-[#2563eb]/30 blur-3xl" />
    <div className="relative p-6 sm:p-8 lg:p-10 space-y-8">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
        <div className="flex items-center gap-5 sm:gap-7">
          <div className="relative shrink-0">
            <div className="absolute inset-0 rounded-full bg-[#38bdf8]/30 blur-2xl" />
            <img src="/logo-siber.png" alt="Logo Siber Polri" className="relative h-24 sm:h-28 w-auto drop-shadow-[0_0_18px_rgba(56,189,248,0.45)]" data-testid="dashboard-logo" />
          </div>
          <div>
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.25em] text-[#7dd3fc]">
              <span className="h-1.5 w-1.5 rounded-full bg-[#22d3ee] animate-pulse shadow-[0_0_8px_#22d3ee]" />
              Sistem Online &middot; {today}
            </div>
            <h1 className="mt-3 font-heading font-black tracking-tight text-3xl sm:text-4xl lg:text-5xl">
              Dashboard Rekap <span className="text-[#38bdf8]">Logistik</span>
            </h1>
            <p className="mt-2 text-sm text-[#bfdbfe]/80 max-w-xl">
              {user.role === "polda" ? `Ringkasan data almatsus ${user.polda}.` : "Ringkasan seluruh inventaris Dittipidsiber dan almatsus Ditressiber Polda jajaran."}
            </p>
          </div>
        </div>
        <PdfButton
          params={{ scope: user.role === "polda" ? "polda" : "summary" }}
          label="Cetak Laporan Rekap"
          testId="dashboard-pdf-button"
          variant="default"
          className="bg-[#0ea5e9] hover:bg-[#38bdf8] text-[#020617] font-semibold shadow-[0_0_24px_rgba(14,165,233,0.45)]"
        />
      </div>
      {children}
    </div>
  </section>
);
